import { isUserLicensed } from '@bb/users';
import { isAssumeOrgType, isAuthForRole } from 'utils';
import type { AuthContextUser } from 'contexts';
import type { VirtualBookForType } from './types';
import type { AppointmentBookingInternalContextType } from '../AppointmentBookingInternalContext';

export const getBookForOptions = ({
  auth,
  listing,
}: {
  auth: AuthContextUser;
  listing: NonNullable<AppointmentBookingInternalContextType['listing']>;
}): VirtualBookForType[] => {
  const result: VirtualBookForType[] = [];
  if (
    isAssumeOrgType(auth.org.type) ||
    isAuthForRole({
      auth,
      org: listing.org.id,
      location: listing.location,
      locations: listing.locations,
      reps: listing.reps,
    })
  ) {
    result.push('others');
  }
  if (!auth.isUnverified && isUserLicensed(auth)) {
    result.push('self');
  }

  return result;
};
